<!--  -->
<template>
  <div class="container">
    <div class="item itemmt">
      <span class="title">发票状态</span>
      <span class="status" v-show="info.status == 0">待开票</span>
      <span class="status" v-show="info.status == 1">开票中</span>
      <span class="status" v-show="info.status == 2">已开票</span>
    </div>
    <div class="ticketType">{{info.invoice_type == 0?'普通发票':'专用发票'}}</div>
    <div class="box">
      <div class="item">
        <span class="title">发票抬头</span>
        <span class="status">{{info.is_company == 0?'个人':'企业'}}</span>
      </div>
      <div class="item">
        <span class="title">学员姓名</span>
        <span class="info">{{info.bill_to}}</span>
      </div>
      <div class="item">
        <span class="title">联系电话</span>
        <span class="info">{{info.phone}}</span>
      </div>
      <div class="item">
        <span class="title">电子邮箱</span>
        <span class="info">{{info.email}}</span>
      </div>
      <div class="item">
        <span class="title">备注</span>
        <span class="info">{{info.memo}}</span>
      </div>
      <div class="item">
        <span class="title">申请日期</span>
        <span class="info">{{info.apply_time}}</span>
      </div>
    </div>

    <button class="updateApply" v-show="info.status == 0" @click="updateApply">修改申请</button>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import moment from 'moment'//解析时间戳
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        info:{}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getTicketDetail(id) {
      this.$http
        .getTicketDetail({
          sign_id: id
        })
        .then(res => {
          if(res.status == 1){
              this.info = res.data
              this.info.apply_time = moment(this.info.apply_time*1000).format('YYYY-MM-DD HH:mm')
          }
        });
    },
    // 修改申请
    updateApply(){
        this.$router.push({ name: "applyTicket", params: { info: this.info } });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let id = this.$route.query.id;
    this.getTicketDetail(id);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  background-color: #f6f5f8;
  .itemmt {
    margin-top: 7px;
    line-height: 50px;
    height: 50px;
  }
  .box {
    background-color: #fff;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .item {
    background-color: #fff;
    height: 35px;
    width: 100%;
    line-height: 35px;
    padding-left: 27px;
    box-sizing: border-box;
    font-size: 16px;
    .title {
      display: inline-block;
      width: 70px;
      color: #7b7b7b;
    }
    .status {
      color: #377dff;
      margin-left: 30px;
    }
    .info {
      color: #222222;
      margin-left: 30px;
    }
  }
  .ticketType {
    margin-top: 7px;
    text-align: center;
    background-color: #fff;
    color: #ed5e2c;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #eaeaea;
    font-size: 17px;
    font-weight: bold;
  }
  .updateApply {
    width: 80%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border: none;
    background-color: #0e87f7;
    color: #fff;
    font-size: 19px;
    border-radius: 25px;
    margin-left: 10%;
    margin-top: 100px;
  }
}
</style>